<script>
  import { onMount } from 'svelte';
  import { get } from 'svelte/store';
  import { asnavigate } from './Utils/asnavigation.js';
  import { useNavigate, useLocation } from 'svelte-navigator';
  const navigate = useNavigate();
  import Paths from './Utils/Paths.svelte';
  import SketchfabModel from './Components/SketchfabModel.svelte';
  import {
    currentLocation,
    pathTrappe,
    alertReload,
    sketchfabId,
    linkPdfId,
    idTrappe,
    nomTrappe,
    choix,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    type,
    couleur,
    epaisseur,
    dureeResistance,
    dimLongueurIdFiche,
    dimLargeurIdFiche,
    sensOuvertureIdFiche,
    fermetureIdFiche,
    typeIdFiche,
    couleurIdFiche,
    epaisseurIdFiche,
    dureeResistanceIdFiche,
    coupeFeuIdPath,
    trappePath,
    quantite,
    commentaire,
  } from './stores.js';
  import { fly } from 'svelte/transition';
  import Header from './Components/Header.svelte';
  import TitleNNumber from './ComponentsInProcess/TitleNNumber.svelte';
  import BtnInfo from './BtnInfo/BtnInfo.svelte';
  import LineSideBar from './ComponentsInProcess/LineSideBar.svelte';
  import Prefooter from './Components/prefooter.svelte';
  import {
    resetTrappeOption,
    saveTrappeInSession,
    getTrappeInSession,
    trappeStoretoObj,
    linkToPdf,
  } from './Utils/saveInDb';

  $alertReload = true;

  // if ($idTrappe.length === 0) {
  //   console.log(`<!-- ===+++ Trappe options empty +++=== -->`);
  //   resetTrappeOption();
  //   asnavigate(navigate, '/LayoutPage');
  // }

  // $choix = '58';
  // $couleur = 'Blanc';
  // $couleurIdFiche = 5;
  // $coupeFeuIdPath = '';
  // $dimLargeur = [300];
  // $dimLargeurIdFiche = '';
  // $dimLongueur = [300];
  // $dimLongueurIdFiche = 2;
  // $dureeResistance = '';
  // $dureeResistanceIdFiche = '';
  // $epaisseur = '';
  // $epaisseurIdFiche = '';
  // $fermeture = 'Pousser / Lâcher';
  // $fermetureIdFiche = 4;
  // $idTrappe = '1';
  // $nomTrappe = 'Métallique ';
  // $quantite = '1';
  // $sensOuverture = 'Sur le côté de 300 mm';
  // $sensOuvertureIdFiche = 3;
  // // $sketchfabUID = 'a663c4108a7f4cce97a03533d69a749d';
  // $trappePath = ['1', '5', '8'];
  // $type = 'Mur';
  // $typeIdFiche = 1;

  // let valid = saveTrappeInSession();

  const location = useLocation();

  $: {
    onMount(async function () {
      // console.log('onMount App begin');
      // getTrappeInSession().done(function (data) {
      //   // console.log(data);
      //   // $nomTrappe = data['sensOuverture'];
      //   // console.log('onMount App end');
      //   for (var key in data) {
      //     console.log(
      //       '-------------- key ' + key + ' has value : ' + data[key]
      //     );
      //     console.log(
      //       '-------------- eval(key) ' + eval(key) + ' has value :' + data[key]
      //     );
      //     console.log(
      //       '-------------- eval(key) ' +
      //         get(eval(key)) +
      //         ' has value :' +
      //         data[key]
      //     );
      //     let storeName = eval(key);
      //     storeName.set('bla bla');
      //     //storeName.set(data[key]);
      //     //storeName = 'zzzz';
      //   }
      // });
    });

    $currentLocation = $location.pathname;
    // console.log(`>>>---- Choix : ${$choix}`);
    // console.log(`>>>---- idTrappe : ${$idTrappe}`);
  }

  let sketchfabUID = 'a663c4108a7f4cce97a03533d69a749d';

  if ($choix == '58') {
    //Trappe métallique - Pousser Lâcher - Blanc
    sketchfabUID = 'a663c4108a7f4cce97a03533d69a749d';
    $linkPdfId = 13;
  } else if ($choix == '68') {
    //Trappe métallique - Clé carré - Blanc
    sketchfabUID = '1c3f17f3d3f641b799ce8bb7ff787f79';
    $linkPdfId = 15;
  } else if ($choix == '78') {
    // Trappe métallique - Clé boites aux lettes - Blanc
    sketchfabUID = '7da86860c2614f4c86516c7bdd3477eb';
    $linkPdfId = 17;
  } else if ($choix == '59') {
    //Trappe métallique - Pousser Lâcher - Blanc mat
    sketchfabUID = 'a663c4108a7f4cce97a03533d69a749d';
    $linkPdfId = 19;
  } else if ($choix == '69') {
    //Trappe métallique - Clé carré - Blanc mat
    sketchfabUID = '1c3f17f3d3f641b799ce8bb7ff787f79';
    $linkPdfId = 21;
  } else if ($choix == '79') {
    // Trappe métallique - Clé boites aux lettes - Blanc mat
    sketchfabUID = '7da86860c2614f4c86516c7bdd3477eb';
    $linkPdfId = 23;
  } else if ($choix == '510') {
    //Trappe métallique - Pousser Lâcher - RAL
    sketchfabUID = 'a663c4108a7f4cce97a03533d69a749d';
    $linkPdfId = 25;
  } else if ($choix == '610') {
    //Trappe métallique - Clé carré - RAL
    sketchfabUID = '1c3f17f3d3f641b799ce8bb7ff787f79';
    $linkPdfId = 27;
  } else if ($choix == '710') {
    // Trappe métallique - Clé boites aux lettes - RAL
    sketchfabUID = '7da86860c2614f4c86516c7bdd3477eb';
    $linkPdfId = 29;
  }

  if ($idTrappe == 2) {
    // sketchfabUID = '2b18f82fe39645708f1f464120b094b9';
    if ($choix == '5') {
      // Trappe Alu Hydro - Pousser Lâcher
      sketchfabUID = '2b18f82fe39645708f1f464120b094b9';
      $linkPdfId = 31;
    } else if ($choix == '6') {
      // Trappe Alu Hydro - Clé carré
      sketchfabUID = 'a6285d66b7554c27bebcfe310bf6b345';
      $linkPdfId = 33;
    } else if ($choix == '7') {
      // Trappe Alu Hydro - Clé boites aux lettes
      sketchfabUID = 'ef986ece96524d90a7f3dd79c3411f8b';
      $linkPdfId = 35;
    }
  }
  if ($idTrappe == 3) {
    sketchfabUID = '48e9402da936431297f877e269b42aea';
    $linkPdfId = 37;
  }
  if ($idTrappe == 4) {
    if ($choix == '13') {
      // Plusieurs étanchéités - Air Poussière - 12,5 mm - Pousser Lâcher
      sketchfabUID = 'b332ee766e564ac5b24b3d52baffa58b';
      $linkPdfId = 39;
    } else if ($choix == '14') {
      // Plusieurs étanchéités - Air Poussière - 15 mm - Pousser Lâcher
      sketchfabUID = 'e2e0237f9abc4eb896f61a35f565c6e0';
      $linkPdfId = 41;
    } else if ($choix == '15') {
      // Plusieurs étanchéités - Air Poussière - 25 mm - Pousser Lâcher
      sketchfabUID = '45411398cff840e6aa90acf7e333fc35';
      $linkPdfId = 43;
    } else if ($choix == '23') {
      // Plusieurs étanchéités - Eau Air Poussière Fumée - 12,5 mm - Pousser Lâcher
      sketchfabUID = 'af22ba76facc4c6e89e5132154c3dd35';
      $linkPdfId = 45;
    } else if ($choix == '24') {
      //Plusieurs étanchéités - Eau Air Poussière Fumée - 2x 12,5 mm - Pousser Lâcher
      sketchfabUID = '221a0013a53b4dbab5a342e942517eea';
      $linkPdfId = 47;
    }
  }

  if ($idTrappe == 5) {
    if ($coupeFeuIdPath == '1a2a3a456a') {
      // Trappe coupe feu  - plafond - 30 min - 18 mm - Pousser Lâcher
      sketchfabUID = 'a748c07d77dd45febee5088572a7f366';
      $linkPdfId = 49;
    } else if ($coupeFeuIdPath == '1a2a3a456b') {
      // Trappe coupe feu - plafond - 30 min - 18 mm - Clé carré
      sketchfabUID = '78512a63cee4490183a78d9f7bf751ba';
      $linkPdfId = 51;
    } else if ($coupeFeuIdPath == '1a2a3a456c') {
      // Trappe coupe feu - plafond - 30 min - 18 mm - Clé boites aux lettes
      sketchfabUID = '8a32abc9ea26493d88b44eea272ae16d';
      $linkPdfId = 53;
    } else if ($coupeFeuIdPath == '1a2a3b456a') {
      //Trappe coupe feu - plafond - 30 min - 2 x 12,5 mm - Pousser Lâcher
      sketchfabUID = '9e2039e834ac4cddacfa58279e486c43';
      $linkPdfId = 55;
    } else if ($coupeFeuIdPath == '1a2a3b456b') {
      //Trappe coupe feu - plafond - 30 min - 2 x 12,5 mm -  Clé carré
      sketchfabUID = '78512a63cee4490183a78d9f7bf751ba';
      $linkPdfId = 57;
    } else if ($coupeFeuIdPath == '1a2a3b456c') {
      //Trappe coupe feu - plafond - 30 min - 2 x 12,5 mm - Clé boites aux lettes
      sketchfabUID = '8a32abc9ea26493d88b44eea272ae16d';
      $linkPdfId = 59;
    }
    // else if ($coupeFeuIdPath == 'b046933aaffb40ee9e82801627a63c20') {
    //   sketchfabUID = '';
    // }
    else if ($coupeFeuIdPath == '1a2b3a456a') {
      // Trappe coupe feu - plafond - 60 min - 2 x 15 mm - Pousser Lâcher
      sketchfabUID = 'b046933aaffb40ee9e82801627a63c20';
      $linkPdfId = 61;
    } else if ($coupeFeuIdPath == '1a2b3a456b') {
      //Trappe coupe feu - plafond - 60 min - 2 x 15 mm - Clé carré
      sketchfabUID = 'c09fd4a6b901467aa506ec4e6b2978ec';
      $linkPdfId = 63;
    } else if ($coupeFeuIdPath == '1a2b3b456a') {
      // Trappe coupe feu - plafond - 60 min -2 x 18 mm  - Pousser Lâcher
      sketchfabUID = 'b046933aaffb40ee9e82801627a63c20';
      $linkPdfId = 65;
    } else if ($coupeFeuIdPath == '1a2b3b456b') {
      //Trappe coupe feu - plafond - 60 min - 2 x 18 mm  - Clé carré
      sketchfabUID = 'c09fd4a6b901467aa506ec4e6b2978ec';
      $linkPdfId = 67;
    } else if ($coupeFeuIdPath == '1a2c3456a') {
      //Trappe coupe feu - plafond - 90 min - 2 x 20 mm - Pousser Lâcher
      sketchfabUID = 'f4f00fde2d9a48d7a0b7fe15ab11fd05';
      $linkPdfId = 69;
    } else if ($coupeFeuIdPath == '1a2c3456b') {
      //Trappe coupe feu - plafond - 90 min - 2 x 20 mm - Clé carré
      sketchfabUID = 'c0fca623d7f74ffbba58fc964751abc9';
      $linkPdfId = 71;
    } else if ($coupeFeuIdPath == '1a2d345') {
      //Trappe coupe feu - plafond - 120 min - 2 x 25 mm - Clé carré
      sketchfabUID = 'fab2cc7a60fa4d0faa0ef6788825a6b6';
      $linkPdfId = 73;
    } else if ($coupeFeuIdPath == '1b2a345a') {
      //Trappe coupe feu  - cloison - 30 min - Pousser Lâcher
      sketchfabUID = '6d7bb1936b7f4a38896633aada494399';
      $linkPdfId = 75;
    } else if ($coupeFeuIdPath == '1b2a345b') {
      //Trappe coupe feu - cloison - 30 min - Clé carré
      sketchfabUID = '7a9536b8dabf46e880fe092b212f3928';
      $linkPdfId = 77;
    } else if ($coupeFeuIdPath == '1b2a345c') {
      //Trappe coupe feu - cloison - 30 min - Clé boites aux lettes
      sketchfabUID = '40107ba8c73f43748fc68949e8b88361';
      $linkPdfId = 79;
    } else if ($coupeFeuIdPath == '1b2b34') {
      //Trappe coupe feu - cloison - 60 min - Clé carré
      sketchfabUID = '25c0b9505f554407a5951a9087e95487';
      $linkPdfId = 81;
    } else if ($coupeFeuIdPath == '1b2c34') {
      //Trappe coupe feu - cloison - 60/30 min - Clé carré
      sketchfabUID = '06e0db45f02543638af8dadd872cea23';
      $linkPdfId = 83;
    } else if ($coupeFeuIdPath == '1b2d345') {
      //Trappe coupe feu - cloison - 90 min - Aimantée
      sketchfabUID = '19c25b58a4024abab246a9a1d83df781';
      $linkPdfId = 85;
    }
  }
  // console.log('recap idTrappe : <strong>' + $idTrappe);
  // console.log('recap choix : <strong>' + $choix);
  // console.log('recap sketchfabUID : <strong>' + sketchfabUID);
  // console.log('recap $coupeFeuIdPath : <strong>' + $coupeFeuIdPath);

  // savetosession();

  // console.log('++++++++++++++++++++++++++++++++++++++++++++++');
  // console.log(clog);
  // console.log('++++++++++++++++++++++++++++++++++++++++++++++');

  onMount(async function () {
    // linkToPdf($linkPdfId);
  });

  function checkForm() {
    const postQuantite = document.querySelector('#as-post-quantite').value;
    const postCommentaire = document.querySelector(
      '#as-post-commentaire'
    ).value;
    console.log(`as-post-quantite : ${postQuantite}`);
    console.log(`as-post-commentaire : ${commentaire}`);
    console.log(`sketchfabUID : ${sketchfabUID}`);
    if (postQuantite > 0) {
      $sketchfabId = sketchfabUID;
      $quantite = postQuantite;
      // let fff = get($quantite);
      // console.log(`get  : ${fff}`);
      $commentaire = postCommentaire;
      // navigate('/process');
      asnavigate(navigate, '/process');
    } else {
      alert('la quatité doit être de au minimum de 1 ou plus');
    }
  }
</script>

<!-- <Header /> -->
<!-- <div class="bg-diago"></div> -->
<Paths namestore="recapitulatif" />
<div class="">
  <div class=" relative" style="z-index:10;">
    <div class="container as-container-phone mx-auto">
      <div class="text-left mt-24"></div>
      <div in:fly="{{ x: 50, duration: 500 }}">
        <!-- <TitleNNumber idFiche="" titre="{'Votre configuration'}" /> -->
        <div class="as-titre">
          Voici un récapitulatif de votre configuration
        </div>
      </div>
      <div in:fly="{{ x: 50, duration: 600 }}">
        <p class="as-text-base">
          Vous pouvez inspecter le modèle 3D sur cette page, il s'agit du modèle
          de base de la trappe Métallique. L'affichage ne prends pas en compte
          certains paramètres que vous avez pu configurer (comme la longueur et
          la largeur choisies etc.)
        </p>
        <p class="as-text-base">
          Vous pouvez revenir à une étape précise pour modifier des paramètres
          en cliquant sur la ligne correspondante.
        </p>
      </div>
    </div>
  </div>
  <div class="as-bg-bloc relative" style="z-index:10;">
    <div class="container  mx-auto">
      <section
        class=" relative pt-0 pb-0 "
        in:fly="{{ x: 100, duration: 800 }}"
      >
        <div class="container container-list mx-auto items-start flex ">
          <div class="w-full md:w-full lg:w-6/12 xl:w-6/12">
            <div
              class="as-col-recap relative flex flex-col min-w-0 break-words mb-6 w-full transition duration-300 transform group "
              aria-label="View item"
              title="View item"
            >
              <blockquote class="relative p-6 w-full">
                <!-- <div
                class="as-line-border"
                in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
              >
                <LineSideBar
                  linecolor="#000"
                  hasIcon="true"
                  idPage="/LayoutPage/1"
                  titre="{'Test : <strong>gras</strong> '}"
                />
              </div> -->

                {#if $nomTrappe}
                  <div
                    class="as-line-border"
                    in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
                  >
                    <LineSideBar
                      linecolor="#000"
                      hasIcon="true"
                      idPage="LayoutPage"
                      titre="{'Choix de la trappe <strong>' +
                        $nomTrappe +
                        '</strong>'}"
                    />
                  </div>
                {/if}
                {#if $type}
                  <div
                    class="as-line-border"
                    in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
                  >
                    <LineSideBar
                      linecolor="#000"
                      hasIcon="true"
                      idPage="/LayoutPage/{$typeIdFiche}"
                      titre="{'Type d’installation : <strong>' +
                        $type +
                        '</strong> '}"
                    />
                  </div>
                {/if}
                {#if $dureeResistance}
                  <div
                    class="as-line-border"
                    in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
                  >
                    <LineSideBar
                      linecolor="#000"
                      hasIcon="true"
                      idPage="/LayoutPage/{$dureeResistanceIdFiche}"
                      titre="{'Durée résistance au feu : <strong>' +
                        $dureeResistance +
                        '</strong> '}"
                    />
                  </div>
                {/if}
                {#if $epaisseur}
                  <div
                    class="as-line-border"
                    in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
                  >
                    <LineSideBar
                      linecolor="#000"
                      hasIcon="true"
                      idPage="/LayoutPage/{$epaisseurIdFiche}"
                      titre="{'Epaisseur : <strong>' +
                        $epaisseur +
                        '</strong> '}"
                    />
                  </div>
                {/if}

                {#if $dimLongueur}
                  <div
                    class="as-line-border"
                    in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
                  >
                    <LineSideBar
                      linecolor="#000"
                      hasIcon="true"
                      idPage="/LayoutPage/{$dimLongueurIdFiche}"
                      titre="{'Longueur de la trappe : <strong>' +
                        $dimLongueur +
                        ' mm</strong>'}"
                    />
                  </div>
                  <div
                    class="as-line-border"
                    in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
                  >
                    <LineSideBar
                      linecolor="#000"
                      hasIcon="true"
                      idPage="/LayoutPage/{$dimLongueurIdFiche}"
                      titre="{'Largeur de la trappe : <strong>' +
                        $dimLargeur +
                        ' mm</strong>'}"
                    />
                  </div>
                {/if}
                {#if $sensOuverture}
                  <div
                    class="as-line-border"
                    in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
                  >
                    <LineSideBar
                      linecolor="#000"
                      hasIcon="true"
                      idPage="/LayoutPage/{$sensOuvertureIdFiche}"
                      titre="{'Côté d’ouverture : <strong>' +
                        $sensOuverture +
                        ' </strong>'}"
                    />
                  </div>
                {/if}

                {#if $fermeture}
                  <div
                    class="as-line-border"
                    in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
                  >
                    <LineSideBar
                      linecolor="#000"
                      hasIcon="true"
                      idPage="/LayoutPage/{$fermetureIdFiche}"
                      titre="{'Fermeture : <strong>' +
                        $fermeture +
                        ' </strong>'}"
                    />
                  </div>
                {/if}
                {#if $couleur != ''}
                  <div
                    class="as-line-border"
                    in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
                  >
                    <LineSideBar
                      linecolor="#000"
                      hasIcon="true"
                      idPage="/LayoutPage/{$couleurIdFiche}"
                      titre="{'Couleur : <strong>' + $couleur + ' </strong>'}"
                    />
                  </div>
                {/if}
                <p class="mb-5"></p>
                <div class="flex flex-wrap items-stretch w-full mb-4 relative">
                  <div class="flex -mr-px">
                    <span
                      class="flex items-center leading-normal bg-grey-lighter rounded rounded-r-none border border-r-0 border-grey-300 px-3 whitespace-no-wrap text-grey-dark"
                      style="border-color: #000;color: #000;background-color:transparent;"
                      >Veuillez entrez la quantité *</span
                    >
                  </div>
                  <input
                    type="number"
                    name="as-post-quantite"
                    id="as-post-quantite"
                    value="{$quantite}"
                    min="1"
                    placeholder="1"
                    step="1"
                    class="flex-shrink flex-grow flex-auto leading-normal w-px  border h-10 border-grey rounded rounded-l-none px-3 relative"
                    style="border-color: #000;color: #000;background-color:transparent;"
                    required
                  />
                </div>
                <p class="mb-6"></p>
                <textarea
                  name="as-post-commentaire"
                  id="as-post-commentaire"
                  value="{$commentaire}"
                  class="leading-normal w-px border h-10 border-grey rounded rounded-l-none px-3 relative"
                  style="width:100%;min-height:130px;border-color: #000;color: #000;background-color:transparent;padding: 15px 15px;"
                  placeholder="Nous laisser un commentaire"></textarea>

                <div class="col-span-3 text-right  flex self-center">
                  <button
                    on:click="{() => checkForm()}"
                    class="as-btn-rounded"
                    style="margin: 20px 0 15px;"
                  >
                    Continuer
                  </button> <BtnInfo isRecap="true"/> 
                </div>
                <!-- <span id="linkToPdf" style="color:#0005;font-size: 13px;"></span> -->
              </blockquote>
            </div>
          </div>
          <div class="w-full md:w-full lg:w-6/12 xl:w-6/12 px-0 relative">
            <!-- <div style="margin-bottom: -150px;position: relative;top: -200px;">
            <SketchfabModel uid="{sketchfabUID}" />
          </div> -->
            <div class="wrapper-sketchfab">
              <SketchfabModel uid="{sketchfabUID}" />
            </div>
            <!-- {$choix} | <a href="https://sketchfab.com/3d-models/{sketchfabUID}" target="_blank">{sketchfabUID}</a> -->
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
<!-- IdTrappe : {$idTrappe} <br />
Path : {$trappePath} <br />
Choix : {$choix} <br /> -->
<!-- CoupeFeuIdPath : {$coupeFeuIdPath} -->

<Prefooter />

<style>
  /* ::placeholder {
    font-family: 'introlight';
    color: rgb(128, 128, 128);
    opacity: 1;
  } */
  /* .as-bg-bloc {
    background: linear-gradient(#000, #000) no-repeat center 100px;
  } */
  .wrapper-sketchfab {
    position: relative;
    top: 80px;
  }
  .as-col-recap {
    /* margin-top: -150px; */
    background-color: #f4f6f8;
  }
  .as-titre {
    position: relative;
    font-family: 'introblack';
    font-size: 35px;
    line-height: 30px;
  }
  .as-titre::after {
    content: '';
    position: absolute;
    inset: auto auto -15px 0;
    border: 4px solid #000;
    width: 40px;
  }
  .as-text-base {
    font-size: 17px;
    line-height: 23px;
    margin-top: 15px;
  }
  .as-text-base:first-child {
    margin-top: 45px;
  }
  .as-text-base:last-child {
    margin-bottom: 35px;
  }
  @media only screen and (max-width: 768px) {
    .as-container-phone {
      padding: 0 30px;
    }
    .mt-24 {
      margin-top: 70px;
    }
    .container-list {
      display: block;
      padding: 0 30px;
    }
    .wrapper-sketchfab {
      position: relative;
      top: 0;
    }
  }
</style>
